import React, { useState,useEffect } from "react";
import Image from "react-bootstrap/Image"; 
import moment from "moment"; 

export const ReferralTableUserBody = ({
  data,
  id,
  src,
  userName,
  refree,
  number,
  referralCode,
  used,
  actions,
  refereeRole,
  refuserId,
  referred,
  referalRole,
  refDate,
  selectedTab,
  enrollDate,
  lastActivity,
  referralQualified,
  lastActivityReferree,
  amount,
  receivingOrgID,
  receivingOrgName,
  amountDisburse,
  last_activity_date,
  setDataWhole,
  sendData,
}) => {
  const [TrDetail, setTrDetail] = useState(false);
  // console.log(data,"affliatesdata")
  useEffect(() => {
    setDataWhole(sendData);
  }, []);
  return (
    <tbody className="w-100 super-admin-all-vendor-main-table-body">
    <tr className="w-100 p-0">
      <td className="p-0 w-100">
        <table className="w-100">
          <tbody className="sd_body_css text-break">
      <tr
        className="superadmin-referral-table-body"
        onClick={() => setTrDetail(!TrDetail)}
        style={{
          overflowWrap: "anywhere",
        }}
      >
        <td style={{ width: "10%" }} className="pl-4">
          {id}
        </td>
        <td style={{ width: "10%" }}>{referralCode}</td>
        <td style={{ width: "10%" }}>
          {refree?.name || "-"}
          {/* <div className="section-one-box">
            <div className="image-user-box">
              <Image
                src={refree.src}
                alt="User Pic"
                title="refree User"
                fluid
              />
            </div>
            <h3>{refree.name}</h3>
          </div> */}
        </td>
        <td style={{ width: "10%" }}>{refuserId || "-"}</td>
        <td style={{ width: "12%" }}>{referred?.name || "-"}</td>
        <td style={{ width: "14%" }}>
          {refereeRole}
          {/* <div className="section-one-box">
            <div className="image-user-box">
              <Image
                src={referred.src}
                alt="User Pic"
                title="refree User"
                fluid
              />
            </div>
            <h3>{referred.name}</h3>
          </div> */}
        </td>
        <td style={{ width: "10%" }}>
          {refDate ? moment(refDate).format("DD/MM/YYYY") : "-"}
        </td>
        <td style={{ width: "10%" }}>
          Registration
        </td>
        <td style={{ width: "10%"}}>{referralQualified}</td>
        {/* {selectedTab === 1 && (
          <>
            <td style={{ width: "10%" }}>{lastActivity}</td>
            <td style={{ width: "10%" }}>{referralQualified}</td>
            <td style={{ width: "10%" }}>
              {moment(lastActivityReferree).format("DD/MM/YYYY")}
            </td>
            <td style={{ width: "10%" }}>{amount}</td>
            <td style={{ width: "10%" }}>{receivingOrgID}</td>
            <td style={{ width: "10%" }}>{receivingOrgName}</td>
            <td style={{ width: "10%" }}>{amountDisburse}</td>
          </>
        )} */}
      </tr>
      {TrDetail && (
        <>
          <tr
            className="superadmin-referral-table-body"
            style={{
              overflowWrap: "anywhere",
            }}
          >
            <td style={{ width: "20%" }} className="pl-4">
              <div className="f12-400">Qualifying Activity Date</div>
              <div className="f12-500">
                {last_activity_date
                  ? moment(new Date(last_activity_date)).format("DD/MM/YYYY")
                  : "N/A"}
              </div>
            </td>
            <td style={{ width: "20%" }} className="pl-4">
              <div className="f12-400">
                Payable Amount <br />
                To Referrer
              </div>
              <div className="f12-500">₹{data?.referralAmount || "0"}</div>
            </td>
            <td style={{ width: "20%" }} className="pl-4">
              <div className="f12-400">
                Payable Amount <br />
                To Referee
              </div>
              <div className="f12-500">₹{data?.refereeAmount || 0}</div>
            </td>
            <td style={{ width: "20%" }} className="pl-4">
              <div className="f12-400">
                Contribution towards <br />
                Udbhav
              </div>
              <div className="f12-500"> ₹{data?.donation || 0}</div>
            </td>
          </tr>
        </>
      )}
    </tbody>
          </table>
        </td>
      </tr>
    </tbody>
  );
};
